import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AdminService } from 'src/app/_services/admin.service';
import Swal from 'sweetalert2';
declare var $ : any;
@Component({
  selector: 'app-protection-of-data',
  templateUrl: './protection-of-data.component.html',
  styleUrls: ['./protection-of-data.component.css']
})

export class ProtectionOfDataComponent implements OnInit {
  myForm: FormGroup;

  loading = false;
  errorMessage = '';
  errorEncountered=false
  isLoggedIn = false;
  isSaving=false
  isVerifying=false
  isCompleted=false
  isFound = false

  name=""

  yieldMessage=""
  constructor(
  private adminService:AdminService, private router:Router) {}

ngOnInit() {
  this.initMainFormFresh()

}

// convenience getter for easy access to form fields
get f() { return this.myForm.controls; }

on_submit(): void {
    if (this.myForm.invalid) {
        return;
    }

    this.name=this.myForm.value.username

    this.isSaving=true
    this.confirmDeletePopUp()

  }


  deleteOrNotDelete(txtConfirm:string){

    if(txtConfirm=="DELETE"){
      this.saveNew()
    }else{
      this.isSaving=false
      this.router.navigate(["/"])
    }
  }
saveNew(){
  let dd = this.formatData()

  this.adminService.requestAccountDelete(dd).subscribe(
  data=>{
    this.isSaving=false
    this.manageResponse(data)
  })
}

 manageResponse(data:any){

  this.isCompleted=true
  if(data['is_found']==1){
    let profile_id=data['profile_id']
    this.router.navigate(["/protection-of-data/verify/",profile_id])
  }else{
    this.yieldMessage="Sorry we cannot find the provided username"
    Swal.fire(this.yieldMessage)
  }
}


initMainFormFresh(){
this.myForm=new FormGroup({
  username: new FormControl('', Validators.compose([Validators.required, Validators.pattern('^[^\\s@]+@[^\\s@]+\\.[^\\s@]{2,}$'), Validators.minLength(1)]))
});
}



formatData(){
  let data = new URLSearchParams();
  data.set('name', this.name);
  return data.toString()
}
confirmDeletePopUp(){
  $("#dataProtectionConfirmModal").modal("show");
}

}
